import { useState, useRef } from "react";
import { useReactToPrint } from 'react-to-print';
import { Grid, Typography, TextField, Popover } from "@mui/material";
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import * as React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, Modal } from '@mui/material';
import { Link } from 'react-router-dom';
import Data from '../data/datas.json';
import InfoIcon from '@mui/icons-material/Info';
import PrintRoundedIcon from '@mui/icons-material/PrintRounded';
import './Principal.css'
import ProgCompleta from '../data/ProgramacaoPrincipal.pdf'
// import Footer from "../components/Footer";

export default function Principal() {
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedEvento, setSelectedEvento] = useState(null);
    const [diaSelecionado, setDiaSelecionado] = useState(0);
    const [searchValue, setSearchValue] = useState('');
    const [anchorEl, setAnchorEl] = useState(null);
    const tableContainerRef = useRef();

    const handleOpenModal = (evento) => {
        setSelectedEvento(evento);
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setSelectedEvento(null);
        setModalOpen(false);
    };

    const RendTable = (indiceDia) => {
        setDiaSelecionado(indiceDia);
    };

    const Print = useReactToPrint({
        content: () => tableContainerRef.current,
    });

    const filteredEventos = Data[diaSelecionado].eventos.filter((evento) =>
        evento.atividades.some((atividade) => atividade.nome.toLowerCase().includes(searchValue.toLowerCase()))
    );


    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <div>
            <Grid container spacing={4}>
                <Grid item xl={12} lg={12} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                    <Grid sx={{ marginTop: '2%' }}>
                        <Typography sx={{ '& a': { textDecoration: 'none', color: '#002758', fontFamily: 'sans-serif', fontWeight: 'bold' } }}>
                            <Link to="/"> Home </Link> <span style={{ color: 'orange', fontWeight: 'bold' }}> {'/'} </span> <Link to="/programacao"> Programação </Link>
                        </Typography>
                    </Grid>
                    <Grid sx={{ marginTop: '2%' }}>
                        <TextField
                            variant="standard"
                            label="Buscar na Programação Principal"
                            size="small"
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                            InputProps={{
                                sx: { borderRadius: 10 },
                                startAdornment:
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid item xl={7} lg={7} xs={12} display="flex" alignItems="center" justifyContent="center" flexDirection="row">
                    <Typography sx={{ fontSize: { xl: '2.8rem', lg: '2.5rem', xs: '1.8rem' }, color: '#FA8100', fontWeight: 'bold', marginRight: '1%' }}>Programação</Typography>
                    <Typography sx={{ fontSize: { xl: '2.8rem', lg: '2.5rem', xs: '1.8rem' }, color: '#FFC923', fontWeight: 'bold' }}>Principal</Typography>
                </Grid>
                <Grid item xl={5} lg={5} xs={12} display="flex" alignItems="center" justifyContent="center" flexDirection="row">
                    <IconButton onClick={handleClick}>
                        <PrintRoundedIcon />
                    </IconButton>
                    <Popover
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                    >
                        <div style={{ display: 'flex', flexDirection: 'column', padding: 20 }}>
                            <Button onClick={Print} color="success">Dia Selecionado</Button>
                            <Button href={ProgCompleta} target="_blank" rel="noreferrer">Programação completa</Button>
                        </div>
                    </Popover>
                </Grid>
                <Grid container spacing={1} display="flex" alignItems="center" justifyContent="center">
                    {Data.map((dia, index) => (
                        <Grid item xl={2} lg={2} xs={12} key={index} display="flex" alignItems="center" justifyContent="center" flexDirection="row">
                            <Button
                                sx={{
                                    fontSize: { xl: '1.8rem', lg: '1.5rem', xs: '1.5rem' },
                                    color: diaSelecionado === index ? '#FA8100' : '#b5b5b5',
                                }}
                                onClick={() => RendTable(index)}
                            >
                                {`> ${dia.dia} Dia - ${dia.data}`}
                            </Button>
                        </Grid>
                    ))}
                </Grid>

                <Grid container justifyContent="center" ref={tableContainerRef}>
                    <Grid item xl={8} lg={8} xs={9} display="flex" alignItems="center" justifyContent="center">
                        <TableContainer component={Paper}>
                            <Table>
                                <TableBody>
                                    {filteredEventos.map((evento, index) => (
                                        <TableRow key={index}>
                                            <TableCell sx={{ backgroundColor: '#FA8100', color: '#fff' }}>{evento.hora}</TableCell>
                                            {evento.atividades.map((atividade, subIndex) => (
                                                <TableCell key={subIndex}>
                                                    {atividade.descricao ? (
                                                        <>
                                                            {atividade.nome}
                                                            <IconButton onClick={() => handleOpenModal(atividade)}>
                                                                <InfoIcon />
                                                            </IconButton>
                                                        </>
                                                    ) : (
                                                        atividade.nome
                                                    )}
                                                </TableCell>
                                            ))}
                                            <TableCell sx={{ color: '#FA8100', fontStyle: 'italic', fontWeight: 'bold', fontSize: 'large' }}>
                                                {evento.local}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>

                    <Modal open={modalOpen} onClose={handleCloseModal}>
                        <Box sx={{ position: 'absolute', top: '10%', left: '50%', transform: 'translate(-50%, 50%)', width: 400, bgcolor: 'background.paper', border: '2px solid #fff', boxShadow: 24, p: 4 }}>
                            <Typography variant="h5">{selectedEvento && selectedEvento.nome}</Typography>
                            {selectedEvento && selectedEvento.imagem && (
                                <img src={selectedEvento.imagem} alt={selectedEvento.nome} style={{ width: '100%', maxHeight: 200, objectFit: 'cover', marginBottom: 8 }} />
                            )}
                            {selectedEvento && selectedEvento.descricao && (
                                <Typography variant="body2">{selectedEvento.descricao}</Typography>
                            )}
                            <Button onClick={handleCloseModal}>Fechar</Button>
                        </Box>
                    </Modal>
                </Grid>
            </Grid>
        </div>
    )
}
